import React, { useEffect, useState, useRef } from "react";
import "../App.css";
import CanvasJSReact from "../canvasjs.react";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import axios from "axios";
import { responsiveFontSizes } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputAdornment from "@material-ui/core/InputAdornment";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import StandardInput from "@material-ui/core/InputBase";
import Typography from "@material-ui/core/Typography";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import CircularProgress from "@material-ui/core/CircularProgress";
import LinearProgress from "@material-ui/core/LinearProgress";
import NumberInput from "semantic-ui-react-numberinput";

import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

const HomePage = ({ token }) => {
  const [data, setData] = useState([]);
  const [ownedStocks, setOwnedStocks] = useState([]);
  const [selectedDate, setDate] = useState(Date.now());
  const [timePeriod, setTimePeriod] = useState("day");
  const [Intervals, setIntervals] = useState("minute");
  const [stockNumber, setStockNumber] = useState(1);
  const [stockPrice, setStockPrice] = useState(0.0);
  const [purchasePlayer, setPurchasePlayer] = useState("Tyler");
  const [purchaseTotal, setPurchaseTotal] = useState(0);
  const [userCash, setUserCash] = useState(100.0);

  //Notification
  const [notification, setNotification] = React.useState(false);
  const [notificationText, setNotificationText] = React.useState("");
  const [notificationSeverity, setNotificationSeverity] = useState("");

  //Interval References
  const selectedDateRef = useRef(selectedDate);
  const timePeriodRef = useRef(timePeriod);
  const dataRef = useRef(data);
  selectedDateRef.current = selectedDate;
  timePeriodRef.current = timePeriod;
  dataRef.current = data;
  const intervalTimer = useRef(false);

  //Loading Spinners
  const [isLoadingAll, setIsLoadingAll] = useState(true);
  const [isLoadingChart, setIsLoadingChart] = useState(true);
  const [isLoadingPurchase, setIsLoadingPurchase] = useState(false);
  const [isLoadingSell, setIsLoadingSell] = useState(false);

  useEffect(() => {
    setIsLoadingChart(true);
    getStocks();
  }, [selectedDate, timePeriod]);

  useEffect(() => {
    if (!token) {
      setIsLoadingAll(false);
    }

    getMyStocks();
    intervalTimer.current = setInterval(() => {
      getStocks();
    }, 10000);

    return () => {
      clearInterval(intervalTimer.current);
    };
  }, []);

  useEffect(() => {
    updatePurchaseStocks();
  }, [purchasePlayer]);

  useEffect(() => {
    setPurchaseTotal(stockPrice * stockNumber);
  }, [stockPrice, stockNumber]);

  const cardContentStyle = {
    display: "flex",
    justifyContent: "center",
    height: "100%",
  };

  const canvasStyle = {
    display: "flex",
    justifyContent: "center",
    height: "100%",
    alignItems: "center",
  };

  const purchaseCardStyle = {
    maxHeight: "300px",
  };

  const cashCardStyle = {
    display: "grid",
    placeItems: "center",
  };

  const firstRowStyle = {
    display: "grid",
    gridTemplateColumns: "minmax(220px, 10%) auto minmax(220px, 10%)",
    gridGap: "10px",
    padding: "5px",
  };

  const secondRowStyle = {
    display: "grid",
    gridTemplateColumns: "auto auto",
    gridGap: "10px",
    padding: "5px",
  };

  const homePageStyle = {};

  const sideBarStyle = {};

  const zeroPad = (num, places) => String(num).padStart(places, "0");

  const getStocks = () => {
    var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
    d.setUTCMilliseconds(selectedDateRef.current);

    let config = {
      params: { date: d },
    };

    axios
      .get("https://bb-exchange.herokuapp.com/" + timePeriodRef.current, config)
      .then((response) => {
        var players = [];
        var playerNames = [];
        var colours = [
          "rgb(183, 28, 28)",
          "rgb(136, 14, 79)",
          "rgb(74, 20, 140)",
          "rgb(26, 35, 126)",
          "rgb(13, 71, 161)",
          "rgb(1, 87, 155)",
          "rgb(0, 96, 100)",
          "rgb(102, 187, 106)",
          "rgb(192, 202, 51)",
          "rgb(245, 127, 23)",
          "rgb(255, 179, 0)",
          "rgb(230, 81, 0)",
          "rgb(78, 52, 46)",
          "rgb(117, 117, 117)",
          "rgb(84, 110, 122)",
          "rgb(100, 30, 22)",
        ];

        response.data.map((datapoint) => {
          let index = players.findIndex((player) => {
            return player.name == datapoint.player;
          });

          if (index != -1) {
            datapoint.y = datapoint.price;
            var d = new Date(datapoint.date);
            datapoint.x = d;
            players[index].dataPoints.push(datapoint);
          } else {
            var newPlayer = {
              type: "line",
              name: datapoint.player,
              markerType: "none",
              dataPoints: [],
              visible:
                dataRef.current.length > players.length
                  ? dataRef.current.filter(
                      (dr) => dr.name == datapoint.player
                    )[0].visible
                  : true,
              color: colours[players.length],
            };

            players.push(newPlayer);
          }
        });

        players.sort(
          (a, b) =>
            b.dataPoints[b.dataPoints.length - 1].price -
            a.dataPoints[a.dataPoints.length - 1].price
        );

        setData(players);
        updatePurchaseStocks();
        setIsLoadingChart(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getMyStocks = () => {
    let config = {
      params: { token: token },
    };

    axios
      .get("https://bb-exchange.herokuapp.com/mystocks", config)
      .then((response) => {
        groupStocks(response.data.stocks);
        setUserCash(response.data.balance);

        setIsLoadingAll(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const groupStocks = (individualStocks) => {
    var groupedStocks = [];

    individualStocks.map((is) => {
      let index = groupedStocks.findIndex((s) => {
        return s.player == is.player;
      });

      if (index != -1) {
        groupedStocks[index].purchasePrice += is.purchasePrice;
        groupedStocks[index].currentPrice += is.currentPrice;
        groupedStocks[index].stockNumber += 1;
        groupedStocks[index].loading = false;
      } else {
        var newStock = {
          player: is.player,
          purchasePrice: is.purchasePrice,
          currentPrice: is.currentPrice,
          stockNumber: 1,
        };

        groupedStocks.push(newStock);
      }
    });

    groupedStocks.sort((a, b) => b.stockNumber - a.stockNumber);

    setOwnedStocks(groupedStocks);
  };

  const updatePurchaseStocks = () => {
    var player = data.find((d) => d.name == purchasePlayer);

    if (player) {
      setStockPrice(player.dataPoints[player.dataPoints.length - 1].price);
    }
  };

  const options = {
    animationEnabled: true,

    axisY: {
      title: "Price",
      includeZero: true,
    },
    toolTip: {
      shared: true,
    },
    data: data,
    axisX: {
      interval: 60,
      intervalType: Intervals,
    },
  };

  const changeVisibility = (index) => {
    var old_data = [...data];
    old_data[index].visible = !old_data[index].visible;

    setData(old_data);
  };

  const handleDateChange = (newDate) => {
    setDate(newDate);
  };

  const changeTimePeriod = (value) => {
    setTimePeriod(value);

    if (value == "hour" || value == "day") {
      setIntervals("minute");
    } else if (value == "month") {
      setIntervals("day");
    } else if (value == "week") {
      setIntervals("hour");
    } else if (value == "year") {
      setIntervals("month");
    }
  };

  const purchaseStocks = () => {
    setIsLoadingPurchase(true);
    axios
      .post("https://bb-exchange.herokuapp.com/purchase", {
        token: token,
        Player: purchasePlayer,
        NumberOfStocks: stockNumber,
      })
      .then((res) => {
        if (res.data.successful) {
          groupStocks(res.data.stocks);
          setUserCash(res.data.balance);
          setNotificationText("Purchase Successful");
          setNotificationSeverity("success");
          setNotification(true);
          setStockNumber(1);
          getStocks();
        } else {
          setNotificationText(res.data.message);
          setNotificationSeverity("error");
          setNotification(true);
        }
        setIsLoadingPurchase(false);
      });
  };

  const sellStock = (name, index) => {
    setIsLoadingSell(true);
    axios
      .post("https://bb-exchange.herokuapp.com/sell", {
        Player: name,
        token: token,
      })
      .then((res) => {
        if (res.data.successful) {
          groupStocks(res.data.stocks);
          setUserCash(res.data.balance);
          setNotificationText("Sold");
          setNotificationSeverity("success");
          setNotification(true);
          setStockNumber(1);
          getStocks();
        }
        setIsLoadingSell(false);
      });
  };

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  return (
    <div className="HomePage" style={homePageStyle}>
      {isLoadingAll ? (
        <div
          style={{
            height: "50vh",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <React.Fragment>
          <Snackbar
            open={notification}
            autoHideDuration={6000}
            onClose={() => setNotification(false)}
          >
            <Alert
              onClose={() => setNotification(false)}
              severity={notificationSeverity}
            >
              {notificationText}
            </Alert>
          </Snackbar>
          {!token && (
            <div style={{ padding: "5px", textAlign: "center" }}>
              <Card variant="outlined">
                <h1>Sign Up To Play</h1>
              </Card>
            </div>
          )}

          <div style={firstRowStyle}>
            <div style={{ display: "grid", gridGap: "10px" }}>
              {token && (
                <Card variant="outlined" style={cashCardStyle}>
                  <CardContent>
                    <div>
                      <Typography variant="h5" component="h2">
                        ${userCash.toFixed(2)}
                      </Typography>
                    </div>
                  </CardContent>
                </Card>
              )}

              <Card variant="outlined">
                <CardContent style={cardContentStyle}>
                  <div className="checkboxes" style={sideBarStyle}>
                    <FormControl>
                      <Select
                        label="Time Period"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={timePeriod}
                        onChange={(e) => changeTimePeriod(e.target.value)}
                      >
                        <MenuItem value="hour">Hour</MenuItem>
                        <MenuItem value="day">Day</MenuItem>
                        <MenuItem value="week">Week</MenuItem>
                        <MenuItem value="month">Month</MenuItem>
                        <MenuItem value="year">Year</MenuItem>
                      </Select>
                    </FormControl>
                    <div>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disableToolbar
                          variant="inline"
                          format="MM/dd/yyyy"
                          margin="normal"
                          id="date-picker-inline"
                          label="Date"
                          onChange={(d) => setDate(d)}
                          value={selectedDate}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
            <Card variant="outlined">
              <CardContent style={canvasStyle}>
                {isLoadingAll ? (
                  <CircularProgress />
                ) : isLoadingChart ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <p>Loading Chart...</p>
                    <CircularProgress />
                  </div>
                ) : (
                  <CanvasJSChart options={options} />
                )}
              </CardContent>
            </Card>
            <div style={{ display: "grid", gridGap: "10px" }}>
              <Card variant="outlined">
                <CardContent style={cardContentStyle}>
                  <div className="checkboxes" style={sideBarStyle}>
                    <h3 style={{ marginBottom: "5px" }}>Players</h3>
                    {data.map((d, index) => (
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                        }}
                        key={d.name}
                      >
                        <FormControlLabel
                          style={{ height: "25px" }}
                          control={
                            <Checkbox
                              name={d.name}
                              onChange={() => changeVisibility(index)}
                              checked={d.visible}
                              style={{ color: d.color }}
                            />
                          }
                          label={
                            d.dataPoints.length > 0 &&
                            d.name +
                              " ($" +
                              d.dataPoints[
                                d.dataPoints.length - 1
                              ].price.toFixed(2) +
                              ")"
                          }
                        />
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>

          {token && (
            <div style={secondRowStyle}>
              <Card variant="outlined" style={purchaseCardStyle}>
                <CardContent>
                  <Typography
                    variant="h5"
                    component="h2"
                    style={{ marginBottom: "10px" }}
                  >
                    Purchase Stocks
                  </Typography>
                  <div>
                    <Select
                      label="Time Period"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={purchasePlayer}
                      onChange={(e) => setPurchasePlayer(e.target.value)}
                      style={{ marginBottom: "20px" }}
                    >
                      {data.map((d, index) => (
                        <MenuItem key={d.name} value={d.name}>
                          {d.name}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel htmlFor="outlined-adornment-amount">
                        Number of stocks
                      </InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-amount"
                        type="number"
                        value={stockNumber}
                        onChange={(text) => setStockNumber(text.target.value)}
                        labelWidth={130}
                        style={{ width: "100px" }}
                      />
                    </FormControl>
                    <p variant="h5" component="h5">
                      <b>Stock Cost:</b> ${stockPrice.toFixed(2)} x{" "}
                      {stockNumber}
                    </p>
                    <p variant="h5" component="h5" style={{ color: "green" }}>
                      <b>Total Cost:</b> ${purchaseTotal.toFixed(2)}
                    </p>

                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={purchaseStocks}
                        style={{ marginRight: "10px" }}
                      >
                        Purchase
                      </Button>
                      {isLoadingPurchase && <CircularProgress size={20} />}
                    </div>
                  </div>
                </CardContent>
              </Card>
              <Card variant="outlined">
                <CardContent>
                  <Typography
                    variant="h5"
                    component="h2"
                    style={{ marginBottom: "10px" }}
                  >
                    Current Stocks
                  </Typography>
                  <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">Player</TableCell>
                          <TableCell align="center">Number of stocks</TableCell>
                          <TableCell align="center">Purchase Price</TableCell>
                          <TableCell align="center">Current Price</TableCell>
                          <TableCell align="center">Profit</TableCell>
                          <TableCell align="center">
                            Actions{" "}
                            {isLoadingSell && <CircularProgress size={20} />}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {ownedStocks.map((row, index) => (
                          <TableRow key={row._id}>
                            <TableCell align="left">{row.player}</TableCell>
                            <TableCell align="center">
                              {row.stockNumber}
                            </TableCell>
                            <TableCell align="center">
                              ${row.purchasePrice.toFixed(2)}
                            </TableCell>
                            <TableCell align="center">
                              ${row.currentPrice.toFixed(2)}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{
                                color:
                                  row.currentPrice - row.purchasePrice > 0
                                    ? "green"
                                    : "red",
                              }}
                            >
                              {(row.currentPrice - row.purchasePrice).toFixed(
                                2
                              )}
                            </TableCell>
                            <TableCell
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <Button
                                variant="contained"
                                color="secondary"
                                onClick={(e) => sellStock(row.player, index)}
                              >
                                Sell
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Card>
            </div>
          )}
        </React.Fragment>
      )}
    </div>
  );
};

export default HomePage;
